import { useState } from "react";
import { Tooltip, IconButton, Modal, Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import CloseIcon from "@mui/icons-material/Close";
import DOMPurify from "dompurify"; // Importamos DOMPurify
import InfoIcon from "@mui/icons-material/Info";

const LayerDescriptionTool = ({ layer }) => {
  const { t, i18n } = useTranslation("main");
  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const isMobile = window.innerWidth < 960;

  return (
    <>
      <Tooltip title={t("layer_description")}>
        <IconButton className={"layerGroupTool-element"} onClick={handleOpen}>
          <InfoIcon />
        </IconButton>
      </Tooltip>

      <Modal open={open} onClose={handleClose}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            bgcolor: "background.paper",
            boxShadow: 24,
            p: "1rem",
            borderRadius: "8px",
            maxHeight: "80vh",
            overflowY: "auto",
            maxWidth: "90vw",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              gap: "1rem",
              paddingBottom: "1rem",
              position: "relative",
            }}
          >
            {!isMobile && (
              <IconButton
                style={{
                  position: "absolute",
                  right: "0",
                }}
                onClick={handleClose}
              >
                <CloseIcon />
              </IconButton>
            )}
            <Typography variant="h6" component="h2" gutterBottom>
              {t("layer_description")}
            </Typography>
          </div>

          <div
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(layer.description[i18n.language]),
            }}
          />
        </Box>
      </Modal>
    </>
  );
};
export { LayerDescriptionTool };
